module.exports = __webpack_public_path__ + "static/img/win10_2.5edae76.png";